import { FunctionComponent, ReactNode, useContext } from "react";
import { Redirect } from "react-router-dom";
import { PepContext, PepState, PepType } from "@lysaab/lysa-pep";

interface Props {
  children: ReactNode;
  fallbackRoute: string;
}

export const PepGuard: FunctionComponent<Props> = ({
  children,
  fallbackRoute,
}) => {
  const { state: pepState } = useContext(PepContext);

  if (isValidNotPep(pepState) || isValidPep(pepState)) {
    return <>{children}</>;
  }

  return <Redirect to={fallbackRoute} />;
};

const isValidNotPep = (pepState: PepState) => {
  return pepState.type === PepType.NOT_PEP;
};

const isValidPep = (pepState: PepState) => {
  if (
    isValidMePep(pepState) ||
    isValidColleaguePep(pepState) ||
    isValidRelativePep(pepState)
  ) {
    return true;
  }
  return false;
};

const isValidMePep = (pepState: PepState) => {
  if (
    pepState.type === PepType.ME &&
    typeof pepState.role !== "undefined" &&
    typeof pepState.country !== "undefined"
  ) {
    return true;
  }
  return false;
};

const isValidColleaguePep = (pepState: PepState) => {
  if (
    pepState.type === PepType.COLLEAGUE &&
    typeof pepState.role !== "undefined" &&
    typeof pepState.country !== "undefined"
  ) {
    return true;
  }
  return false;
};

const isValidRelativePep = (pepState: PepState) => {
  if (
    pepState.type === PepType.RELATIVE &&
    typeof pepState.role !== "undefined" &&
    typeof pepState.country !== "undefined"
  ) {
    return true;
  }
  return false;
};
